import React from 'react';
import { Button } from '@mui/material';

const DSButton = (props: React.ComponentProps<typeof Button>) => {
  return <Button {...props} />;
};

export default DSButton;
